import React from 'react'

import './Container.scss'

const Container: TContainer = ({
	children,
	size = 'normal',
	customWidth = null,
	active = true
}) => {
	return (
		<div
			className={`Container size-${size} ${active ? 'active' : ''}`}
			style={
				customWidth
					? {
							width: customWidth
					  }
					: {}
			}
		>
			{children}
		</div>
	)
}

export default Container

type TContainerProps = {
	children: any
	size?: 'normal' | 'small' | 'large' | 'measure'
	customWidth?: number
	active?: boolean
}

type TContainer = React.FC<TContainerProps>
